// extracted by mini-css-extract-plugin
module.exports = {"extendedCodemirror":"codemirror_extendedCodemirror___r5VR","no-ligatures":"codemirror_no-ligatures__daL4X"};